import { render, staticRenderFns } from "./HistoricoTipoEquipo.vue?vue&type=template&id=40525a02&scoped=true&"
import script from "./HistoricoTipoEquipo.vue?vue&type=script&lang=ts&"
export * from "./HistoricoTipoEquipo.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricoTipoEquipo.vue?vue&type=style&index=0&id=40525a02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40525a02",
  null
  
)

export default component.exports